"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sheetName = exports.version = exports.optional = exports.notes = exports.location = exports.standard = exports.qrData = exports.protocol = exports.rawData = exports.baselineData = exports.wellInfo = exports.header = void 0;
function header(item) {
    const { run } = item;
    let headerSection = []; // Holder of all rows
    headerSection.push(["Run Name", run.name]);
    headerSection.push(["Date & Time", run.timestamp]);
    return headerSection;
}
exports.header = header;
function wellInfo(item) {
    let { targets } = item.run;
    let wellNums = ["Well"];
    let channels = ["Channel"];
    let targetNames = ["Target"];
    let sampleNames = ["Sample Name"];
    let thresholds = ["Threshold"];
    let cqs = ["Cq"];
    targets.map((target) => {
        wellNums.push((target.wellNumber + 1).toString() || "");
        channels.push(target.color || "");
        targetNames.push(target.name || "");
        sampleNames.push(target.sampleName || "");
        thresholds.push(target.threshold.toString() || "");
        cqs.push(target.cq.toFixed(2).toString() || "");
    });
    return [
        wellNums,
        channels,
        targetNames,
        sampleNames,
        thresholds,
        cqs
    ];
}
exports.wellInfo = wellInfo;
function baselineData(item, show) {
    let { targets } = item.run;
    let cycleNum = item.protocol.cycleNums;
    let baselineSection = [
        ["Baseline Subtracted Relative Fluorescence"]
    ];
    targets.map((target) => {
        let singleTargetData = [];
        singleTargetData.push(`Well ${target.wellNumber + 1} ${target.color}`);
        for (let i = 0; i < cycleNum; i++) {
            singleTargetData.push(target.baselineData[i]);
        }
        baselineSection.push(singleTargetData);
        singleTargetData = [];
    });
    return baselineSection;
}
exports.baselineData = baselineData;
function rawData(item, show) {
    let { targets } = item.run;
    let cycleNum = item.protocol.cycleNums;
    let rawDataSection = [
        ["Raw Fluorescence"]
    ];
    targets.map((target) => {
        let singleTargetData = [];
        singleTargetData.push(`Well ${target.wellNumber + 1} ${target.color}`);
        for (let i = 0; i < cycleNum; i++) {
            singleTargetData.push(target.rawData[i]);
        }
        rawDataSection.push(singleTargetData);
        singleTargetData = [];
    });
    return rawDataSection;
}
exports.rawData = rawData;
function protocol(item) {
    let { protocol } = item;
    let protocolSection = [];
    protocolSection.push(["Protocol", protocol.name]);
    protocolSection.push([null, "Temp", "Time(ms)"]);
    protocolSection.push([
        "Reverse Transcription",
        protocol.rtTemp,
        protocol.rtTime
    ]);
    protocolSection.push([
        "Denature",
        protocol.firstDenatureTemp,
        protocol.firstDenatureTime
    ]);
    protocolSection.push(["Cycles", protocol.cycleNums]);
    protocolSection.push([
        "Cycling Denature",
        protocol.denatureTemp,
        protocol.denatureTime
    ]);
    protocolSection.push(["Anneal", protocol.annealTemp, protocol.annealTime]);
    protocolSection.push([
        "Extension",
        protocol.extensionTemp,
        protocol.extensionTime
    ]);
    return protocolSection;
}
exports.protocol = protocol;
function qrData(item) {
    let { run } = item;
    if (run.sku) {
        return [
            ["QR Data"],
            ["SKU", "Lot Number", "Expiration Date"],
            [run.sku, run.lotNumber, run.expirationDate]
        ];
    }
    else {
        return [[null], [null], [null]];
    }
}
exports.qrData = qrData;
function standard(item, runType) {
    const emptyStandard = {
        efficiencies: null,
        rSquares: null,
        yIntercepts: null,
        slopes: null
    };
    let standardData = item.standardCurve;
    let showStandard = runType === "Standard Curve" || runType === "Quantitative";
    let standardSection = [];
    standardSection.push(["Run Type", runType]);
    if (showStandard) {
        if (standardData) {
            standardSection.push([
                "Standard Curve",
                standardData.name
            ]);
        }
        else {
            standardSection.push([
                "Standard Curve",
                "Warning: Standard Curve Data omitted. Data not found in cloud"
            ]);
        }
    }
    else {
        standardSection.push([
            "Standard Curve"
        ]);
    }
    standardSection.push([null, "Green", "Red"]);
    if (showStandard && standardData) {
        const standardGreen = standardData.green;
        const standardRed = standardData.red;
        standardSection.push([
            "E",
            standardGreen.efficiencies,
            standardRed.efficiencies
        ]);
        standardSection.push([
            "R^2",
            standardGreen.rSquares,
            standardRed.rSquares
        ]);
        standardSection.push([
            "Y Intercept",
            standardGreen.yIntercepts,
            standardRed.yIntercepts
        ]);
        standardSection.push([
            "Slopes",
            standardGreen.slopes,
            standardRed.slopes
        ]);
    }
    else {
        standardSection.push(["E"], ["R^2"], ["Y Intercept"], ["Slopes"]);
    }
    return standardSection;
}
exports.standard = standard;
function location(item) {
    let { run } = item;
    return [
        ["Sample Type", item.run.sampleType],
        ["Location", run.location],
        ["Location Tag", run.locationTag],
        ["Latitude", run.latitude, "Longitude", run.longitude]
    ];
}
exports.location = location;
function notes(item, show) {
    if (!show) {
        return [[null]];
    }
    let { run } = item;
    return [["Notes", run.notes]];
}
exports.notes = notes;
function optional(data) {
    let main = [];
    let others = [];
    const space = [null];
    const optDataKeys = Object.keys(data); //string array of object keys
    if (optDataKeys.length > 0) {
        optDataKeys.forEach(key => {
            let value = data[key];
            switch (typeof value) {
                case "string": {
                    main.push([key, value]);
                    break;
                }
                case "number": {
                    main.push([key, value]);
                    break;
                }
                case "boolean": {
                    main.push([key, value]);
                    break;
                }
                case "object": {
                    if (Array.isArray(value)) {
                        main.push([key, ...value]);
                    }
                    else {
                        others.push(space, [key], ...optional(value));
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        });
    }
    const extraSectionObjToArray = [...main, ...others];
    return extraSectionObjToArray;
}
exports.optional = optional;
function version(item) {
    let { run } = item;
    let systemInfo = run.version;
    let versionSection = [];
    versionSection.push(["HW Number", systemInfo.serialNumber]);
    versionSection.push(["FW Version", systemInfo.firmwareVersion]);
    versionSection.push(["SW Version", systemInfo.appVersion]);
    // }
    versionSection.push(["Duration", run.duration]);
    return versionSection;
}
exports.version = version;
function sheetName(item, sheetNames) {
    // remove invalid characters
    let name = "Run " + item.run.name.replace(/[\/:*?"<>|]/g, "-");
    /**
     * parse names down to 27 characters and check for duplicate names
     * if duplicate exists, set last 3 characters with (1) [total length now 30]
     **/
    let tmp = name.toUpperCase();
    sheetNames[tmp] = (sheetNames[tmp] || 0) + 1;
    let strIndex = sheetNames[tmp];
    if (name.length > 31) {
        let strSliced = name.slice(0, 27);
        if (strIndex > 1) {
            name = strSliced + `(${strIndex - 1})`;
        }
        else {
            name = strSliced;
        }
    }
    else {
        name = strIndex > 1 ? name + `(${strIndex - 1})` : name;
    }
    return name;
}
exports.sheetName = sheetName;
